const LANGUAGES = {
	PL: {
		name: 'Polski',
		flag: 'pl',
	},
	EN: {
		name: 'English',
		flag: 'gb',
	},
	DE: {
		name: 'Deutsch',
		flag: 'de',
	},
} as const;

export default LANGUAGES;
